// extracted by mini-css-extract-plugin
export default {"header":"PreviewUploadTeamForm_header__LqTzM","row":"PreviewUploadTeamForm_row__DUK+B"};